import validateEmail from '../domain/EmailBusinessRules';
import OrderNotFoundError from '../domain/OrderNotFoundError';

export default async function login(repository, { email, orderHigherIdExt }) {
  validateEmail(email);

  const response = await repository.loginWithoutIdk({
    email,
    orderHigherIdExt,
  });

  if (!response.hasAccess) {
    throw new OrderNotFoundError();
  }

  return response;
}
